









import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import SectionModule from '~/store/section';
import DocumentUploadModule from '~/store/documentUpload';
import ProgramModule from '~/store/program';
import EnrollmentModule from '~/store/enrollment';
import EligibilityModule from '~/store/eligibility';

@Component<Header>({
})
export default class Header extends Vue {
    @Resolve
    public sectionStore!: SectionModule;

    @Resolve
    uploadModule!: DocumentUploadModule;

    @Resolve
    public program!: ProgramModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Resolve
    public eligibility!: EligibilityModule;

    redirectToLandingPage() {
        this.uploadModule.clearStore();
        this.sectionStore.resetSelections();
        this.program.clearStore();
        this.enrollment.clearStore();
        this.eligibility.clearStore();
        this.$router.push('/');
    }
    

}
